import axios from '.';

export default {
  getTrackingLinks,
  createTrackingLink,
  updateTrackingLink,
  deleteTrackingLink,
  getTrackingLink,
  trackView
};

async function trackView(data) {
  const response = await axios.post('/api/tracking-links/track-view', data);
  return response.data;
}

async function getTrackingLinks(page = 1, limit = 10) {
  const urlStr = `/api/tracking-links?page=${page}&limit=${limit}`;
  const response = await axios.get(urlStr);
  return response.data;
}

async function getTrackingLink(id) {
  const urlStr = `/api/tracking-links/${id}`;
  const response = await axios.get(urlStr);
  return response.data;
}

async function createTrackingLink(data) {
  const response = await axios.post('/api/tracking-links', data);
  return response.data;
}

async function updateTrackingLink(id, data) {
  const response = await axios.patch(`/api/tracking-links/${id}`, data);
  return response.data;
}

async function deleteTrackingLink(id) {
  const response = await axios.delete(`/api/tracking-links/${id}`);
  return response.data;
}

